"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOfficeStatus = void 0;
__exportStar(require("../Notary/Office"), exports);
const class_validator_1 = require("class-validator");
const Office_1 = __importDefault(require("../Customer/Office"));
const classTransformer_1 = require("../classTransformer");
const Address_1 = __importDefault(require("./Address"));
const DeedType_1 = __importDefault(require("./DeedType"));
const User_1 = __importDefault(require("./User"));
const Notary_1 = require("../Notary");
class Office extends Office_1.default {
}
exports.default = Office;
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({
        groups: [
            "createFolder",
            "createDeedType",
            "createDocumentType",
            "createRule",
            "createRole",
            "createOfficeRole",
        ],
        message: "UID is required",
    }),
    __metadata("design:type", String)
], Office.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createOffice"], message: "ID IdNote is required" }),
    __metadata("design:type", String)
], Office.prototype, "idNot", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createOffice"], message: "Name is required" }),
    __metadata("design:type", String)
], Office.prototype, "name", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createOffice"], message: "CRPCEN is required" }),
    __metadata("design:type", String)
], Office.prototype, "crpcen", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsNotEmpty)({ groups: ["createOffice"], message: "Address is required" }),
    (0, class_validator_1.ValidateNested)({ groups: ["createOffice"] }),
    (0, classTransformer_1.Type)(() => Address_1.default),
    __metadata("design:type", Address_1.default)
], Office.prototype, "address", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], Office.prototype, "office_status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => DeedType_1.default),
    __metadata("design:type", Array)
], Office.prototype, "deed_types", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => User_1.default),
    __metadata("design:type", Array)
], Office.prototype, "users", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Notary_1.OfficeFolder),
    __metadata("design:type", Array)
], Office.prototype, "office_folders", void 0);
var EOfficeStatus;
(function (EOfficeStatus) {
    EOfficeStatus["ACTIVATED"] = "ACTIVATED";
    EOfficeStatus["DESACTIVATED"] = "DESACTIVATED";
})(EOfficeStatus || (exports.EOfficeStatus = EOfficeStatus = {}));
